import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=2b79c94a&scoped=true&"
import script from "./MainTab.vue?vue&type=script&lang=js&"
export * from "./MainTab.vue?vue&type=script&lang=js&"
import style0 from "./MainTab.vue?vue&type=style&index=0&id=2b79c94a&prod&lang=stylus&"
import style1 from "./MainTab.vue?vue&type=style&index=1&id=2b79c94a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79c94a",
  null
  
)

export default component.exports